import React from 'react';
import Navigation from '../Shared/Navigation/Navigation';
import FundingBanner from './FundingBanner/FundingBanner';

const Funding = () => {
    return (
        <div>
            <Navigation></Navigation>
            <FundingBanner></FundingBanner>
        </div>
    );
};

export default Funding;